<script lang="ts">
import {defineComponent, PropType} from "vue";
import ModalDialog from "../ob1/ModalDialog.vue";
import {Gallery, Section} from "../../../orange/broadband/internet/showcase/components/models/SingleOfferDetail";

export default defineComponent({
    name: "ThreeColumnsEditoPopin",
    components: {ModalDialog},
    props: {
        popinId: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        visual: {
            type: Object as PropType<Gallery | null>,
            required: false,
            default: null
        },
        sections: {
            type: Array as PropType<Array<Section>>,
            required: true
        },
        mentions: {
            type: Object as PropType<string | null>,
            required: false,
            default: null
        },
        firstColumnSections: {
            type: Array as PropType<Array<Section>>,
            required: true
        },
        secondColumnSections: {
            type: Array as PropType<Array<Section>>,
            required: true
        },
        thirdColumnSections: {
            type: Array as PropType<Array<Section>>,
            required: true
        }
    },
});
</script>

<template>
    <modal-dialog
        :id="popinId"
        :modal-button-label="'Fermer'"
        :action-label="'Ouvrir'"
        :modal-title="title"
    >
        <template #modalBody>
            <div v-if="visual" class="text-center">
                <img :src="visual.url" :alt="visual.alt" class="img-fluid" />
            </div>
            <template v-for="section in sections">
                <h4 v-if="section.title" class="lead m-0 p-0" v-html="section.title"></h4>
                <div v-if="section.icon" class="col-12 d-flex">
                    <span :class="section.icon" class="icon h1 align-self-center text-primary3"></span>
                    <p class="ms-1" v-html="section.paragraph" />
                </div>
                <div v-else class="col-12 d-flex">
                    <p v-html="section.paragraph" />
                </div>
            </template>
            <div class="row mt-1">
                <div class="col-12 col-md-4">
                    <template v-for="section in firstColumnSections">
                        <h4 v-if="section.title" class="lead m-0 p-0 text-primary" v-html="section.title"></h4>
                        <div v-if="section.icon" class="col-12 d-flex">
                            <span :class="section.icon" class="icon h1 align-self-center text-primary3"></span>
                            <p class="ms-1" v-html="section.paragraph" />
                        </div>
                        <div v-else class="col-12 d-flex">
                            <p v-html="section.paragraph" />
                        </div>
                    </template>
                </div>
                <div class="col-12 col-md-4">
                    <template v-for="section in secondColumnSections">
                        <h4 v-if="section.title" class="lead m-0 p-0 text-primary" v-html="section.title"></h4>
                        <div v-if="section.icon" class="col-12 d-flex">
                            <span :class="section.icon" class="icon h1 align-self-center text-primary3"></span>
                            <p class="ms-1" v-html="section.paragraph" />
                        </div>
                        <div v-else class="col-12 d-flex">
                            <p v-html="section.paragraph" />
                        </div>
                    </template>
                </div>
                <div class="col-12 col-md-4">
                    <template v-for="section in thirdColumnSections">
                        <h4 v-if="section.title" class="lead m-0 p-0 text-primary" v-html="section.title"></h4>
                        <div v-if="section.icon" class="col-12 d-flex">
                            <span :class="section.icon" class="icon h1 align-self-center text-primary3"></span>
                            <p class="ms-1" v-html="section.paragraph" />
                        </div>
                        <div v-else class="col-12 d-flex">
                            <p v-html="section.paragraph" />
                        </div>
                    </template>
                </div>
            </div>
            <p v-if="mentions" class="font-size-12" v-html="mentions" />
        </template>
    </modal-dialog>
</template>
